import {FC, useEffect} from 'react';
import {Button, Menu} from 'antd';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import styles from './Header.module.scss'
import {useRootStore} from '../../../app/context/root-store-context.ts';
import {observer} from 'mobx-react-lite';

const Header: FC = observer(() => {
    const location = useLocation();
    const navigateTo = useNavigate();
    const {
        loginPage: {logOut, logOutSubmitStatus},
    } = useRootStore();


    const onLogOut = () => {
        logOut();
    }

    const menuItems = [
        {key: '/', label: <Link to="/">Главная</Link>},
        {key: '/files', label: <Link to="/articles">Статьи</Link>},
        {key: '/sites', label: <Link to="/sites">Сайты</Link>},
        {
            key: 'logout',
            label: <Button type="default" htmlType="button" onClick={onLogOut}>Выйти</Button>,
            className: styles.logoutButton,
        }
    ];

    useEffect(() => {
        if (logOutSubmitStatus?.state === 'fulfilled') {
            navigateTo('/login');
        }
    }, [logOutSubmitStatus?.state]);

    return (
        <>
            <Menu
                className={styles.wrap}
                mode="horizontal"
                selectedKeys={[location.pathname]}
                items={menuItems}
            />
        </>

    );
});

export default Header;